import { createIcon } from '@chakra-ui/icons';

export const Switches = createIcon({
  displayName: 'Switches',
  viewBox: '0 0 14 14',
  path: [
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3390_2207)">
        <path
          d="M3.79297 0.58374H10.2096C11.668 0.58374 12.8346 1.75041 12.8346 3.20874C12.8346 4.66707 11.668 5.83374 10.2096 5.83374H3.79297"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
        />
        <path
          d="M3.79297 5.83374C5.24272 5.83374 6.41797 4.65849 6.41797 3.20874C6.41797 1.75899 5.24272 0.58374 3.79297 0.58374C2.34322 0.58374 1.16797 1.75899 1.16797 3.20874C1.16797 4.65849 2.34322 5.83374 3.79297 5.83374Z"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M10.2096 13.4171H3.79297C2.33464 13.4171 1.16797 12.2504 1.16797 10.7921C1.16797 9.33378 2.33464 8.16711 3.79297 8.16711H10.2096"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
        />
        <path
          d="M10.209 13.417C11.6587 13.417 12.834 12.2417 12.834 10.792C12.834 9.34224 11.6587 8.16699 10.209 8.16699C8.75924 8.16699 7.58398 9.34224 7.58398 10.792C7.58398 12.2417 8.75924 13.417 10.209 13.417Z"
          stroke="currentColor"
          strokeWidth="1.16667"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_3390_2207">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
